import { render } from "./FavouriteView.vue?vue&type=template&id=5eb12c35&scoped=true"
import script from "./FavouriteView.vue?vue&type=script&lang=js"
export * from "./FavouriteView.vue?vue&type=script&lang=js"

import "./FavouriteView.vue?vue&type=style&index=0&id=5eb12c35&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb12c35"]])

export default __exports__